<template>
	<right-panel :datas="connects" @onClose="onClose" ref="right-panel">
		<div slot="header">
			<translate v-if="!memberForm.memberDis">Add Members</translate>
			<translate v-if="memberForm.memberDis">Change Members</translate>
		</div>
		<div slot="content" class="wrapper-padding" style="height: 100%" @click="selectFocus()">
			<el-form ref="memberForm" :rules="rules" :model="memberForm" class="memberForm">
				<!-- <el-form-item :label="attrText.member" prop="value">
          <el-autocomplete popper-class="my-autocomplete" v-model.trim="memberForm.value"
                           :fetch-suggestions="memberSearch" custom-item="allMember"
                           :placeholder="attrText.inputName" @select="memberSelect" class="auto-complete"
                           :disabled="memberForm.memberDis">
          </el-autocomplete>
        </el-form-item> -->
				<el-form-item :label="attrText.type" style="display: none">
					<el-select v-model="memberForm.type">
						<el-option :label="attrText.administrator" value="1"></el-option>
						<el-option :label="attrText.ordinary" value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="accountId">
					<!-- <el-select ref="members" v-model="memberForm.accountId" multiple filterable remote reserve-keyword :default-first-option="true" :placeholder="attrText.inputName" :loading="loading" :filter-method="remoteMethod" :focus="selectFocus()" @change="onChangeSelect">
						<el-option class="select-item" v-for="item in filteredOptions" :key="item.id" :label="item.name" :value="item.id"> {{ item.name }}<br />{{ item.account }} </el-option>
					</el-select> -->
					<el-select ref="members" v-model="memberForm.accountId" multiple filterable :placeholder="attrText.inputName" :loading="loading" @change="onChangeSelect">
						<el-option class="select-item" v-for="item in memberForm.list" :key="item.id" :label="item.name" :value="item.id"> {{ item.name }}<br />{{ item.account }} </el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer" class="detail-btn">
			<el-button type="primary" :disabled="enableSubmitting" @click="onSubmit()">
				<translate>Submit</translate>
			</el-button>
			<el-button @click="$refs['right-panel'].onClose()">
				<translate>Cancel</translate>
			</el-button>
		</div>
	</right-panel>
</template>

<script>
import STORE_CONST from '../../../store/consts'
import { Utils } from '../../../config'
import RightPanel from '../../common/right-panel'
import Vue from 'vue'

// 资源名称提示
Vue.component('allMember', {
	functional: true,
	render: function (h, ctx) {
		let item = ctx.props.item
		return h('li', ctx.data, [h('div', { attrs: { class: 'name' } }, [item.name]), h('div', {}, [item.account])])
	},
	props: {
		item: { type: Object, required: true },
	},
})
export default {
	name: 'WorkgroupAddMember',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			connects: null,
			loading: false,
			enableSubmitting: true,
			filteredOptions: [],
			memberForm: {
				list: [],
				value: '',
				type: '0',
				accountId: null,
				memberDis: false,
			},
			memberName: false,
			rules: {
				value: [{ required: true, message: this.$gettext('Please input members name'), trigger: 'change' }],
			},
		}
	},
	computed: {
		attrText() {
			return this.getTranslateText()
		},
	},
	created() {
		setTimeout(() => {
			if (this.connects.account) {
				this.memberForm = Object.assign({}, this.memberForm, {
					memberDis: true,
					value: this.connects.name,
					type: this.connects.isAdmin ? '1' : '0',
					accountId: this.connects.id,
				})
			}
		}, 300)
		this.getAllMember()
	},
	methods: {
		// 提取翻译文本
		getTranslateText() {
			return {
				member: this.$gettext('Member'),
				type: this.$gettext('Type'),
				administrator: this.$gettext('administrator'),
				ordinary: this.$gettext('Ordinary Member'),
				inputName: this.$gettext('Please input members name or account search'),
				inputSearch: this.$gettext('Search'),
			}
		},
		// 获取所有成员
		getAllMember() {
			let params = {
				page_size: Utils.config.maxPageSize,
			}
			this.$store.dispatch(STORE_CONST.LOG.GET_ACCOUNT_NAME, params).then((res) => {
				let filterParams = {
					id: this.$route.params.id,
					data: {
						page_size: Utils.config.maxPageSize,
					},
				}
				this.$store.dispatch(STORE_CONST.WORKGROUP.GET_MEMBER_LIST, filterParams).then((exits) => {
					const exitIds = new Set(exits.objects.map((e) => e.id))
					this.memberForm.list = res.objects.filter((item) => !exitIds.has(item.id))
				})
			})
		},
		// 资源名称搜索提示结果
		memberSearch(queryString, cb) {
			let allResourceName = this.memberForm.list
			let results = queryString ? allResourceName.filter(this.createFilter(queryString)) : allResourceName
			// 调用 callback 返回建议列表的数据
			cb(results)
		},
		createFilter(queryString) {
			return (restaurant) => {
				return restaurant.name.indexOf(queryString) === 0 || restaurant.account.indexOf(queryString) === 0
			}
		},
		// 选择成员名字
		memberSelect(item) {
			this.memberForm.value = item.name
			this.memberForm.accountId = item.id
		},
		// 选中
		onChangeSelect(val) {
			console.log('select-val', val)
			this.$refs.members.query = ''
		},
		selectFocus(event, a, b) {
			if (this.$refs.members) {
				this.$refs.members.$el.children[0].children[1].focus()
			}
		},
		remoteMethod(query) {
			if (query !== '') {
				this.loading = true
				setTimeout(() => {
					this.loading = false
					this.filteredOptions = this.memberForm.list.filter((item) => {
						if (item.name && item.account) {
							return item.name.indexOf(query) > -1 || item.account.indexOf(query) > -1
						}
					})
				}, 200)
			} else {
				this.filteredOptions = []
			}
		},
		onSubmit() {
			this.$refs['memberForm'].validate((valid) => {
				if (valid) {
					let params = {
						projectId: this.$route.params.id,
						data: {
							account_id: this.memberForm.accountId,
							role: 0,
							// role: Number(this.memberForm.type)
						},
					}
					if (!this.memberForm.accountId) {
						this.$notify({
							type: 'error',
							message: this.$gettext('Member is found'),
						})
					} else {
						if (this.connects.account) {
							this.$store.dispatch(STORE_CONST.WORKGROUP.PATCH_MEMBER, params).then((res) => {
								if (this.memberForm.memberDis) {
									this.$notify({
										type: 'success',
										message: this.$gettext('Change success'),
									})
								} else {
									this.$notify({
										type: 'success',
										message: this.$gettext('Add success'),
									})
								}
								this.$emit('callback')
								this.$refs['right-panel'].onClose()
							})
						} else {
							this.$store.dispatch(STORE_CONST.WORKGROUP.ADD_MEMBER, params).then((res) => {
								this.$notify({
									type: 'success',
									message: this.$gettext('Add success'),
								})
								this.$emit('callback')
								this.$refs['right-panel'].onClose()
							})
						}
					}
				} else {
					return false
				}
			})
		},
		// 关闭创建集群
		onClose() {
			this.connects = null
			this.$emit('onClosePanel')
		},
	},
	watch: {
		items: {
			handler: function (newVal) {
				if (this.connects) {
					this.connects = null
					setTimeout(() => {
						this.connects = this.items
					}, 300)
				} else {
					this.connects = this.items
				}
			},
			deep: true,
		},
		'memberForm.accountId': {
			handler: function () {
				// this.$refs.members.$el.children[0].children[1].focus()
				if (this.memberForm.accountId.length) {
					this.enableSubmitting = false
					if (this.$refs.members) {
						this.$refs.members.$el.children[0].children[1].focus()
						this.$refs.members.$el.children[0].children[1].placeholder = this.attrText.inputSearch
					}
				} else {
					this.enableSubmitting = true
					this.$refs.members.$el.children[0].children[1].placeholder = ''
				}
			},
		},
	},
	components: {
		RightPanel,
	},
}
</script>
<style lang="scss" rel="stylesheet/scss">
.memberForm {
	.auto-complete {
		width: 100%;
	}
	.el-input__inner {
		border: none;
	}
	.el-select__input {
		width: 160px !important;
	}
	.el-select .el-tag {
		background-color: #e4e8f1;
		border-color: #fff;
		color: #48576a;
		i.el-icon-close:hover {
			background-color: #48576a;
		}
	}
	.el-tag--primary.is-hit {
		border-color: #48576a;
	}
}
.select-item {
	height: auto;
}
</style>



// WEBPACK FOOTER //
// workgroup-add-member.vue?751f787b